import {isArray} from 'lodash';

import {getStoreFileName} from 'ultra/helpers/storage';
import {getFileName} from 'ultra/helpers/files';
import {isFile} from 'ultra/helpers/utils';

export const getFileMeta = (file) => {
  let img, name, removed;

  if (isFile(file)) {
      name = getFileName(file)
      img = URL.createObjectURL(file)
      if (file.size === 0) removed = true
  } else if (typeof file === 'string') {
      name = getStoreFileName(file)
      img = file
  }

  return {img, name, removed}
}

export const getFileAmount = (data) => {
  let count = 0
  if (data) {
      Object.keys(data).map(i => {
          if (!(getFileMeta(data[i]).removed)) {
              count += 1
          }
      })
  }
  return count || 0;
}

// import {getFilterValue} from './config';
// import {formatTelegram} from './format';
// import {get} from '../Helpers/http';
// import {getClientConfig} from 'ultra/configs/general';
// const {api} = getClientConfig(window)
// export async function getForm(formId) { // modId
//   return await get(`${api}/form/${formId}`);
// }

// // TODO: refactor and move
// export const getTelegramMessage = (form, fields, title, filters) => {
//     let message = `${title}

// `;

//     let photos;

//     Object.keys(form).map(control => {
//       const fieldIndex = Object.keys(fields).find(item => fields[item].id === control);
//       if (!fieldIndex) return;

//       const field = fields[fieldIndex];

//       if (field.type === 'link') return;

//       if (field.type === 'image') {
//         photos = form[control];
//         return;
//       }

//       if (field.type === 'gallery') {
//         photos = form[control]; // array
//         return;
//       }

//       if (field.type === 'hidden') {
//         message += `  ${field.placeholder}
// `;
//         return;
//       }

//       if (field.type === 'checkbox') {
//         message += `  ${field.placeholder}
// `;
//         return;
//       }

//       if (field.type === 'filter') {
//         const value = getFilterValue(filters, field.source, form[control]);
//         const placeholder = field.placeholder || filters[field.source].label;
//         message += `  ${placeholder}: ${value}
// `;
//         return;
//       }

//       if (field.handler === 'telegram') {
//         message += `  ${field.placeholder}`;

//         const {tg, tgFormated} = formatTelegram(form[control]);
//         message += `: ${tg} (${tgFormated})
// `;

//         return;
//       }

//       message += `  ${field.placeholder}: ${form[control]}
// `;
//     })

//     return photos ? {message, photos} : {message};;
// }
